import { GetEpiFavoriteOrdersResponse, useGetEpiFavoriteOrdersMutation } from '@services';
import { useEffect, useMemo, useState } from 'react';

export const useEpiFavoriteOrdersPageVM = () => {
    const [orders, setOrders] = useState<GetEpiFavoriteOrdersResponse>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [searchTerm, setSearchTerm] = useState<string>('');

    const [getEpiFavoriteOrders, { data, isLoading, isError }] = useGetEpiFavoriteOrdersMutation();

    useEffect(() => {
        getEpiFavoriteOrders(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data) {
            setOrders(data);
        }

        if (isError) {
            setErrorMessage('Une erreur est survenue lors du chargement des commandes favorites EPI');
        }
    }, [data, isLoading, isError]);

    const filteredOrders = useMemo(() => {
        if (!searchTerm.trim()) {
            return orders;
        }
        return orders.filter(
            (order) =>
                order.id.toString().includes(searchTerm.toLowerCase()) || order.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [orders, searchTerm]);

    return {
        orders: filteredOrders,
        isLoading,
        errorMessage,
        searchTerm,
        setSearchTerm
    };
};
